import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

const ROUTE_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  pilots: 'Pilots',
  'weekly-logs': 'Weekly Logs',
  walkthroughs: 'Walkthroughs',
  reports: 'Reports',
  guide: 'Administrator Guide',
  organization: 'Organization',
  structure: 'Structure',
  team: 'Team',
  settings: 'Settings',
  organizations: 'Organizations',
  subscriptions: 'Subscriptions',
  'payment-links': 'Payment Links',
  users: 'Users',
  new: 'New',
};

export function useBreadcrumbs(currentPageLabel?: string): BreadcrumbItem[] {
  const location = useLocation();
  const params = useParams();

  return useMemo(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    const items: BreadcrumbItem[] = [];
    let pathAccumulator = '';

    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i];
      if (!segment) continue;
      pathAccumulator += `/${segment}`;

      const isUuid = /^[0-9a-f-]{36}$/i.test(segment);
      const isLastSegment = i === segments.length - 1;
      const isParamValue = Object.values(params).includes(segment);

      if (isUuid || isParamValue) {
        continue;
      }

      const label = ROUTE_LABELS[segment] || segment;

      items.push({
        label,
        href: isLastSegment ? undefined : pathAccumulator,
      });
    }

    const lastItem = items[items.length - 1];
    if (currentPageLabel && lastItem) {
      lastItem.label = currentPageLabel;
    }

    return items;
  }, [location.pathname, params, currentPageLabel]);
}
